import { axios } from '../../clients/axios'
import { DATEPICKER, dayjs, MMDDYYYY } from '../../util/date'

const complaintHeaders = [
  { value: 'refNo', text: 'Ticket ID' },
  { value: 'requester', text: 'Requested By', width: '40%' },
  { value: 'complaintTitle', text: 'Complaint Title' },
  // {value: 'description', text: 'Description'},
  { value: 'dateCreated', text: 'Date' },
  // {value: 'bed', text: 'Unit'},
  { value: 'status', text: 'Status' },
  { value: 'actions', text: 'Actions' }
  // {value: 'amount', text: 'Amount'},
  // {value: 'quantity', text: 'Quantity'},
]

// const excludeItems = ['_id', '__v']

export default {
  namespaced: true,
  state: {
    complaints: [],
    total: 0,
    pendingCount: 0
  },
  getters: {
    getComplaints: (state, getters, rootState, rootGetters) => {
      const aliases = rootGetters['users/getAliases']
      let parsedComplaints = []
      // let complaints = state.complaints
      state.complaints.map((raw) => {
        const alias = aliases.find((a) => a.tenantId === raw.tenantId)
        let complaint = {}
        complaint.complaintId = raw.complaintId
        complaint.refNo = raw.refNo
        complaint.complaintTitle = raw.complaintTitle
        complaint.dateCreated = dayjs(raw.dateCreated).format(MMDDYYYY)
        complaint.requester =
          (alias && alias.name) ||
          (raw.tenant_details.firstName && raw.tenant_details.lastName
            ? raw.tenant_details.firstName + ' ' + raw.tenant_details.lastName
            : raw.tenant_details.username)
        complaint.unitName = raw.bed_details && raw.bed_details.bedName
        complaint.description = raw.description
        complaint.status = raw.status
        complaint.images = raw.images
        complaint.notes = raw.notes
        complaint.note_details = raw.note_details
        complaint.dueDate = dayjs(raw.dueDate).format(DATEPICKER)

        parsedComplaints.push(complaint)
      })

      return parsedComplaints
      // return state.complaints
    },
    getHeaders: () => {
      return complaintHeaders.map((header) => {
        header.align = 'left'
        header.sortable = true

        return header
      })
    },
    getPendingCount: (state) => {
      return state.pendingCount
    }
  },
  mutations: {
    fetchComplaints(state, complaints) {
      state.complaints = complaints
    },
    fetchPendingCount(state, count) {
      state.pendingCount = count
    }
  },
  actions: {
    async fetchComplaintsAction(context, params) {
      const { page, limit, sortBy, sortDesc, search, status } = params

      let uri = `${
        process.env.VUE_APP_API_URL
      }/complaints/search?limit=${limit}&page=${page - 1}`

      if (status && status != 'all') {
        uri += `&status=${status}`
      }
      if (sortBy) {
        uri += `&sortBy=${JSON.stringify(sortBy)}`
      }
      if (sortDesc) {
        uri += `&sortDesc=${JSON.stringify(sortDesc)}`
      }
      if (search) {
        uri += `&search=${JSON.stringify(search)}`
      }

      const complaints = await axios.get(uri, { withCredentials: true })

      context.commit('fetchComplaints', complaints.data.data)

      return {
        limit: limit,
        count: complaints.data.count
      }
    },
    async resolveComplaintsAction(context, params) {
      const { complaintId, note } = params
      await axios.put(
        `${process.env.VUE_APP_API_URL}/complaints/${complaintId}/resolve`,
        { note },
        { withCredentials: true }
      )
    },
    async fetchPendingComplaintsCountAction(context) {
      const count = await axios.get(
        `${process.env.VUE_APP_API_URL}/complaints/count/pending`,
        { withCredentials: true }
      )

      context.commit('fetchPendingCount', count.data.count)
    },
    async addNoteAction(context, params) {
      const { complaintId, note } = params
      try {
        const result = await axios.put(
          `${process.env.VUE_APP_API_URL}/complaints/note/${complaintId}`,
          { note },
          { withCredentials: true }
        )
        return Promise.resolve(result)
      } catch (err) {
        let response = 'There was a problem processing your request.'

        if (err.response.status == '403') {
          response = 'You are not authorized to update the complaint'
        }
        return Promise.reject(response)
      }
    },
    async updateComplaintsStatusAction(context, params) {
      const { complaintId, status, dueDate } = params
      try {
        const result = await axios.put(
          `${process.env.VUE_APP_API_URL}/complaints/status/${complaintId}`,
          { status, dueDate },
          { withCredentials: true }
        )

        return Promise.resolve(result)
      } catch (err) {
        let response = 'There was a problem processing your request.'

        if (err.response.status == '403') {
          response = 'You are not authorized to update the complaint'
        }
        return Promise.reject(response)
      }
    }
  }
}
